import { types as sdkTypes } from './sdkLoader';

const { Money } = sdkTypes;

export const bytesToMB = bytes => {
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

/**
 * Checks if an array is valid (not null, undefined, or empty).
 * @param {array} arr - The array to check.
 * @returns {boolean} True if the array is valid, false otherwise.
 */
export const isArrayLength = arr => {
  // Check if the input parameter is an array and has a length greater than zero.
  return Array.isArray(arr) && (arr.length > 0 ?? false);
};

export const isWindowDefined = () => {
  return typeof window !== 'undefined';
};

export const truncateId = (id, length = 10) => {
  if (!id) return null;
  if (id?.length > length) {
    return `${id.substring(0, length)}...`;
  }
  return id;
};

export const normalizedStatus = status => status?.trim().toLowerCase();

export const generateYearOptions = (startYear = 1900) => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: currentYear - startYear + 1 }, (v, i) => {
    const year = currentYear - i;
    return { label: year.toString(), value: year.toString() };
  });
};

export const maskString = input => {
  // Check if the input is less than or equal to 4 characters long
  if (input.length <= 4) {
    return input;
  }

  // Get the last 4 characters of the input
  const lastFour = input.slice(-4);

  // Replace the remaining characters with asterisks
  const masked = '*'.repeat(input.length - 4) + lastFour;
  return masked;
};
export const sortArrayByLabel = arr => {
  return arr.sort((a, b) => {
    // Compare the label values of each object, converting to lowercase for case-insensitive comparison
    const labelA = a.label.toLowerCase();
    const labelB = b.label.toLowerCase();

    if (labelA < labelB) {
      return -1;
    }
    if (labelA > labelB) {
      return 1;
    }

    // labels must be equal
    return 0;
  });
};

export const extractFileExtension = file => {
  if (!file && typeof window !== 'undefined') return null;
  return file.name.substring(file.name.lastIndexOf('.') + 1);
};

export const createMoney = (amount, currency) => {
  if (!amount || !currency) return null;
  return new Money(amount ?? 0, currency);
};

export const keepValidCMSChars = inputString => {
  // This regex matches all characters that aren't part of the German alphabet, numerics or spaces
  const regex = /[^a-zA-Z0-9äöüß ]/g;

  // Remove text enclosed within square brackets followed by a URL enclosed within parentheses
  const updatedString = inputString.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

  // Replace all matches with an empty string
  return updatedString.replace(regex, ' ');
};
